import React from 'react';
import {Avatar, Grid, ListItem, ListItemAvatar, ListItemText, Paper, Box, Typography, Stack} from "@mui/material";
import {Payments, Receipt, ReceiptLong, Work as WorkIcon, AccountBalanceWallet, Speed} from "@mui/icons-material";
import formatNumber from "../../../../../helpers/formatNumber";

interface MaliOzetProps {
    kisi: any;
}

const MaliOzet = ({kisi}: MaliOzetProps) => {
    return (
        <Box sx={{ mt: 2, pt: 2, borderTop: '1px solid rgba(0,0,0,0.08)' }}>
            <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1.5, px: 1 }}>
                <AccountBalanceWallet color="primary" sx={{ fontSize: 20 }} />
                <Typography variant="subtitle1" fontWeight={800} sx={{ textTransform: 'uppercase', letterSpacing: 1 }}>Mali Özet</Typography>
            </Stack>
            
            <Grid container spacing={1.5}>
                <Grid item xs={12} sm={6} md={4}>
                    <OzetCard icon={<ReceiptLong />} label="Güncel Bakiye" value={formatNumber(kisi.bakiye)} color="primary.main" />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <OzetCard 
                        icon={<Speed />} 
                        label="Bu Ay Mesailer" 
                        value={`${kisi?.buAyMesailer?.gun ?? 0}G / ${kisi?.buAyMesailer?.saat ?? 0}S`} 
                        color="info.main" 
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <OzetCard 
                        icon={<WorkIcon />} 
                        label="Geçen Ay Mesailer" 
                        value={`${kisi?.gecenAyMesailer?.gun ?? 0}G / ${kisi?.gecenAyMesailer?.saat ?? 0}S`} 
                        color="grey.600" 
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <OzetCard icon={<Receipt />} label="Cari Bakiye" value={formatNumber(kisi.cariBakiye)} color="secondary.main" />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <OzetCard icon={<Payments />} label="Bu Ay Avans" value={formatNumber(kisi?.buAyMesailer?.avans ?? 0)} color="warning.main" />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <OzetCard icon={<Payments />} label="Geçen Ay Avans" value={formatNumber(kisi?.gecenAyMesailer?.avans ?? 0)} color="grey.600" />
                </Grid>
            </Grid>
        </Box>
    );
};

const OzetCard = ({ icon, label, value, color }: { icon: React.ReactNode, label: string, value: string, color: string }) => (
    <Box sx={{ 
        p: 1.2, borderRadius: '16px', bgcolor: 'grey.50', border: '1px solid rgba(0,0,0,0.02)',
        display: 'flex', alignItems: 'center', gap: 1.2, height: '60px'
    }}>
        <Avatar sx={{ bgcolor: color, width: 28, height: 28 }}>
            {React.cloneElement(icon as React.ReactElement, { sx: { fontSize: 15 } })}
        </Avatar>
        <Box sx={{ minWidth: 0, flexGrow: 1 }}>
            <Typography variant="overline" fontWeight={800} color="textSecondary" sx={{ lineHeight: 1, display: 'block', fontSize: '0.65rem' }}>{label}</Typography>
            <Typography variant="subtitle2" fontWeight={900} noWrap>{value}</Typography>
        </Box>
    </Box>
);

export default MaliOzet;
